import { PromptSaveDirectiveModule } from '@b2b/common/directives';
import { LoadACMECheckoutResolver, ThemesDataResolver } from '@b2b/common/resolvers';
import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { OrderDataResolver } from '../resolvers';

import { OrdersPaymentModule } from './controllers/OrdersPaymentController';

export const OrdersPaymentView = angular
  .module('acme.view.application.orders.payment', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.directive.detailList',
    PromptSaveDirectiveModule,
    OrdersPaymentModule,
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const ordersPayment = {
      name: 'application.orders.payment',
      url: '/:orderId/payment',
      views: {
        'subview-main': {
          controller: 'OrdersPaymentController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/orders/payment/payment.tpl.html',
        },
      },
      data: {
        pageTitle: 'Order Balance',
        /** Secure With Permissions **/
      },
      resolve: {
        OrderData: OrderDataResolver(),
        ThemesData: ThemesDataResolver({ includeEmail: true }),
        ACMECheckout: LoadACMECheckoutResolver(),
      },
    };

    $stateProvider.state(ordersPayment);
  }).name;
